module.exports = __webpack_public_path__ + "img/thumbnail.5fada88e.jpg";